<template>

  <!-- Icons Accordion Block -->
  <page-block
    bg-image-contain
    v-if="hasElements"
    :bg-file="value.file"
    :bg-color="value.bgColor"
    class="icons-accordion-block"
    :text-color="value.textColor"
    :text-align="value.textAlign"
    :width-class="value.widthClass"
    :overlay-class="value.paddingClass">

    <titled-text-element
      no-file
      no-body
      :value="value"/>

    <div
      class="ibs-mt hide-last hide-first"/>

    <icons-accordion-element
      :value="element"
      :key="element.id"
      v-for="element in value.elements"
      class="icons-accordion-block__element"/>

  </page-block>

</template>

<script>

  import PageBlock from '@src/components/page/page-block';
  import PageBlockMixin from '@src/mixins/page-block-mixin';
  import TitledTextElement from '@src/components/element/titled-text-element';
  import IconsAccordionElement from '@src/components/element/icons-accordion-element';

  export default {
    name: 'icons-accordion-block',
    mixins: [
      PageBlockMixin,
    ],
    props: {
      value: {
        type: Object,
        required: true,
      },
    },
    components: {
      PageBlock,
      TitledTextElement,
      IconsAccordionElement,
    },
  };

</script>

<style lang="scss">

  .icons-accordion-block {
    color: inherit;

    &__element {
      margin-top: $ibs-y;
    }
  }

</style>
